export default __webpack_public_path__ + "static/media/watch_diconnected.231ee34b.svg";